import React, { useEffect } from 'react';
import { PillTabs, I18nText } from '@welldev-group/react-comp-lib';
import PropTypes from 'prop-types';
import { StringParam, withDefault, useQueryParams } from 'use-query-params';
import withQueryParamsProvider from '../../../../../../shared/components/withQueryParamsProvider';
import List from './WorkspaceList';

const WorkspaceTab = ({ id, userAffiliateId }) => {
  const [query, setQuery] = useQueryParams({
    tab: withDefault(StringParam, ''),
  });

  const { tab } = query;

  const getItems = () => [
    {
      key: 0,
      title: <I18nText id="user.list.status.active" />,
      getContent: () => (
        <List
          key="active"
          status="active"
          id={id}
          userAffiliateId={userAffiliateId}
        />
      ),
    },
    {
      key: 1,
      title: <I18nText id="user.list.status.deactivated" />,
      getContent: () => (
        <List
          key="deactivated"
          status="deactivated"
          id={id}
          userAffiliateId={userAffiliateId}
        />
      ),
    },
  ];

  useEffect(() => {
    setQuery({ tab: 'workspaces' }, 'replaceIn');
  }, [tab]);

  return (
    <div className="col-grid col-bleed">
      <PillTabs items={getItems()} tab={tab} />
    </div>
  );
};

WorkspaceTab.propTypes = {
  id: PropTypes.number.isRequired,
  userAffiliateId: PropTypes.number.isRequired,
};

export default withQueryParamsProvider(WorkspaceTab);
